import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { UserRoleChipField } from 'pages/UserActions/components/UserRoleChipField';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider, useShowController } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Link } from 'shared/mui/Link/Link';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { FunctionField, TextField } from 'shared/react-admin/Fields';
import { UserAction } from 'types/embedded/userAction';

export const UserActionsShowTable = (): JSX.Element => {
  const translate = useTypedTranslate();
  const { createPathWithQuery } = useCreatePathWithQuery();

  const { record } = useShowController<UserAction>();
  const to = createPathWithQuery(
    {
      resource: Resources.UserActions,
      type: 'list',
    },
    {
      filter: {
        entityId: record?.entityId,
        entityName: [record?.entityName],
      },
    },
  );

  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '163px' } } }}>
      <TableRowWrapper label={translate('app.table.entity')}>
        <TextField source="translatedEntityName" />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.entityId')}>
        <Link component={RouterLink} sx={{ color: 'primary.main' }} to={to}>
          {record?.entityId}
        </Link>
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.user')}>
        <FunctionField
          emptyText={EMPTY_FIELD}
          render={(record: UserAction) => `${record.user.firstName} ${record.user.lastName}`}
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.email')}>
        <FunctionField
          render={(record: UserAction) => record?.user?.corporateEmail || record?.user?.email}
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.role')}>
        <RecordContextProvider value={record?.user}>
          <UserRoleChipField />
        </RecordContextProvider>
      </TableRowWrapper>
      <TableRowWrapper label="IP">
        <TextField source="ip" />
      </TableRowWrapper>
    </CardTable>
  );
};
